let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lRoZt")).then(() => parcelRequire('a1RAT'));